import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
// 1. IMPORT the SERVER_BASE_URL
import { fetchPagesByFlyer, SERVER_BASE_URL } from '../api/thamanService';
import Loader from '../components/Loader';
import ErrorMessage from '../components/ErrorMessage';

export default function PagesListPage() {
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { flyerId } = useParams();

  useEffect(() => {
    const getPages = async () => {
      try {
        setError(null);
        setIsLoading(true);
        const data = await fetchPagesByFlyer(flyerId);
        setPages(data);
      } catch (err) {
        setError('Failed to fetch pages.');
      } finally {
        setIsLoading(false);
      }
    };

    getPages();
  }, [flyerId]);

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Pages for Flyer #{flyerId}</h1>

      {isLoading && <Loader message="Fetching pages..." />}
      {error && <ErrorMessage message={error} />}

      {!isLoading && !error && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {pages.length > 0 ? (
            pages.map(page => (
              <Link key={page.id} to={`/pages/${page.id}/offers`}>
                <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                  {/* 2. UPDATE the image src to use the full server URL */}
                  <img 
                    src={`${SERVER_BASE_URL}${page.file_path}`} 
                    alt={`Page ${page.page_number}`} 
                    className="w-full h-auto object-cover" 
                    // Add an error handler for placeholder images
                    onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/400x600?text=Image+Not+Found' }}
                  />
                  <div className="p-4">
                    <p className="font-bold text-center">Page {page.page_number}</p>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <p className="col-span-full text-center text-gray-500 py-4">No pages found for this flyer.</p>
          )}
        </div>
      )}
    </div>
  );
}